import { render, staticRenderFns } from "./Presences.vue?vue&type=template&id=648153f6&"
import script from "./Presences.vue?vue&type=script&lang=js&"
export * from "./Presences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports